module.exports = __webpack_public_path__ + "static/media/meet.15ee0409.png";